var map = {
	"./IMG_1_INAUGURACAO.png": 95712,
	"./IMG_2_INAUGURACAO.png": 24683,
	"./IMG_3_INAUGURACAO.png": 20030,
	"./IMG_4_INAUGURACAO.png": 75185,
	"./IMG_5_INAUGURACAO.png": 24420,
	"./IMG_6_INAUGURACAO.png": 88831,
	"./IMG_7_INAUGURACAO.png": 29394,
	"./IMG_8_INAUGURACAO.png": 58085,
	"./IMG_9_INAUGURACAO.png": 5368,
	"./IMG_ABRE_INAUGURACAO.png": 55559,
	"./IMG_NEXT_INAUGURACAO.png": 76582
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 33858;